export default "bg-header.png"